<template>
  <a-list
    itemLayout="horizontal"
    :dataSource="data"
  >

  </a-list>
</template>

<script>
export default {
  name: 'BindingSettings',
  data () {
    return {
      data: []
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
